
import env from '@beam-australia/react-env'
import { Box, Button } from '@material-ui/core'
import { Auth } from 'api/index'
import { bosscatHomeServicesLogo, icons, idVerified, mailAtSign } from 'assets/index'
import { authActions, userActions } from 'ducks/actions'
import { getUser, getUserPrimaryEmail } from 'ducks/selectors'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { history } from 'helpers'
type Props = {}

const auth0AppId = env('AUTH0_CLIENT_ID')

const VerifyEmail = (props: Props) => {

    const [sendVerificationEmail, setSendVerificationEmail] = useState(false)
    const [isCheckingVerification, setIsCheckingVerification] = useState(false)

    const push = history.usePush()
    const dispatch = useDispatch()
    const userInfo = Auth.getUserInfo()
    const user = useSelector(getUser)
    const userEmail = userInfo?.email;

    useEffect(() => {
        const accessToken = Auth.getAccessToken()

        if (!accessToken) {
            console.log('No access token available for verification check')
            return
        }

        const checkEmailVerification = async () => {
            try {
                setIsCheckingVerification(true)
                const freshUserInfo = await Auth.fetchFreshUserInfo(accessToken)

                if (freshUserInfo && freshUserInfo.email_verified) {

                    Auth.setUserInfo(JSON.stringify(freshUserInfo), true)

                    push('u/register')
                } else {
                    setIsCheckingVerification(false)
                }
            } catch (error) {
                console.error('Error checking email verification:', error)
                setIsCheckingVerification(false)
            }
        }

        checkEmailVerification()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSendVerificationEmail = () => {
        const userId = userInfo?.sub?.split('|')[1] || userEmail || ''
        dispatch(userActions.sendVerificationEmail({ userEmail: userId, auth0AppId }, (success) => {
            if (success) {
                setSendVerificationEmail(true)
            } else {
                toast.error("Failed to send verification email")
            }
        }))
    }

    const handleAlreadyVerified = () => {
        dispatch(authActions.logoutRequest())
        push('')
    }

    const handleCheckVerification = async () => {
        const accessToken = Auth.getAccessToken()

        if (!accessToken) {
            toast.error("No access token available")
            return
        }

        try {
            setIsCheckingVerification(true)
            const freshUserInfo = await Auth.fetchFreshUserInfo(accessToken)

            if (freshUserInfo && freshUserInfo.email_verified) {
                const remember = Boolean(localStorage.getItem('pro_app:accessToken'))
                Auth.setUserInfo(JSON.stringify(freshUserInfo), remember)

                dispatch(userActions.fetchCurrentUser((fetchSuccess) => {
                    if (fetchSuccess) {
                        push('/')
                    } else {
                        dispatch(userActions.createUser(null, (createSuccess) => {
                            if (createSuccess) {
                                push('/')
                            } else {
                                toast.error("Failed to create user")
                                setIsCheckingVerification(false)
                            }
                        }))
                    }
                }))
            } else {
                toast.info("Email not verified yet. Please check your inbox and click the verification link.")
                setIsCheckingVerification(false)
            }
        } catch (error) {
            console.error('Error checking email verification:', error)
            toast.error("Error checking verification status")
            setIsCheckingVerification(false)
        }
    }

    return (
        <Box width={"100%"} display="flex" flexDirection="column" alignItems={"center"} gridGap="16px" paddingTop={"40px"}>
            {sendVerificationEmail ? <>
                <img src={bosscatHomeServicesLogo} style={{ width: "280px", height: "66px", marginBottom: "96px" }} alt="bosscatHomeServicesLogo" />
                <img src={mailAtSign} alt="mailAtSign" />
                <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0", color: "#000" }}>CHECK YOUR INBOX</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", color: "#000" }}>{`We sent the verification link to your email: ${userEmail}`}</p>
            </> : <>
                <img src={bosscatHomeServicesLogo} style={{ width: "280px", height: "66px", marginBottom: "96px" }} alt="bosscatHomeServicesLogo" />
                <img src={idVerified} alt="idVerified" />
                <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0", color: "#000" }}>VERIFY YOUR ACCOUNT</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", color: "#000" }}>As a last step, we need you to verify your account. We 've sent you a verification link to your email: {userEmail}</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", maxWidth: "450px", textAlign: "center", color: "#000" }}>You can request a new email with the instructions to verify your account by clicking on the following button.</p>
                <Button onClick={handleSendVerificationEmail} style={{ backgroundColor: "white", color: "#2e7bf7" }} variant="outlined" startIcon={<icons.Email style={{ color: "#2e7bf7", textTransform: "none" }} />}>{'Request New Verification'}</Button>
                <Button onClick={handleAlreadyVerified} style={{ backgroundColor: "#2e7bf7", color: "#fff" }} variant="outlined" startIcon={<icons.Email style={{ color: "#fff", textTransform: "none" }} />}>{'I have already verified my email'}</Button>
            </>}
        </Box>
    )
}

export default VerifyEmail
